import * as ArchiveModal from 'archive/components/modals/ArchiveModal';
import {pluralize} from 'BenchlingUtil';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import notifications from 'notifications';
import {withLoadingScreen} from 'util/Promises';

import {ReviewLifecyclesSettingsPageQuery} from './__generated/ReviewLifecyclesSettingsPageQuery';
import {bulkArchiveReviewLifecycles, bulkUnarchiveReviewLifecycles} from './ReviewLifecyclesDAO';

type ReviewLifecycleGraphQL = ExtractByTypename<
  ReviewLifecyclesSettingsPageQuery['organizations'][number],
  'OrganizationNode'
>['reviewLifecycles'][number];

export function onReviewLifecyclesArchive(
  reviewLifecycles: Array<ReviewLifecycleGraphQL>,
  refetchResults: () => Promise<void>
): void {
  const filteredReviewLifecycles = reviewLifecycles.filter((rlc) => !rlc.archiveRecord);

  async function archiveHandler(reviewLifecycleIds: Array<string>, purpose: string): Promise<void> {
    await withLoadingScreen(bulkArchiveReviewLifecycles(reviewLifecycleIds, purpose), 'Archiving...')
      .then((response) => {
        notifications.success(
          `${pluralize(reviewLifecycleIds.length, 'Review Process')} successfully archived.`
        );
      })
      .catch(notifications.notifyError);
    await refetchResults();
  }

  ArchiveModal.open({
    items: filteredReviewLifecycles.map((rlc) => ({...rlc, name: rlc.currentVersion.name})),
    onArchive: archiveHandler,
  });
}

export async function onReviewLifecyclesUnarchive(
  reviewLifecycles: Array<ReviewLifecycleGraphQL>,
  refetchResults: () => Promise<void>
): Promise<void> {
  const filteredReviewLifecycles = reviewLifecycles.filter((rlc) => rlc.archiveRecord);
  const reviewLifecycleIds = filteredReviewLifecycles.map((rlc) => rlc.id);
  await bulkUnarchiveReviewLifecycles(reviewLifecycleIds)
    .then((response) => {
      notifications.success(
        `${pluralize(reviewLifecycleIds.length, 'Review Process')} successfully unarchived.`
      );
    })
    .catch(notifications.notifyError);
  await refetchResults();
}
